<template>
    <transition name="slide-fade">
        <div class="carousel-item"
            v-show="currentSlide === index" >

             <picture>
              <source :srcset="slidesm1[index]" media="(max-width: 450px)">
              <source :srcset="slide">
               <img :src="slide" :alt="`img-${index}`"/>
            </picture>
            <div class="hero-header el">
              <h3 class="slide-in-bottom">{{title}}</h3>
              <p class="slide-in-bottom">{{text}}</p>              
            </div>
            <div class="hero-header en">
              <h3 class="slide-in-bottom">{{title}}</h3>
              <p class="slide-in-bottom">{{texten}}</p>              
            </div>
             
        </div> 
    </transition>
</template>
<script>

export default {
  props: ['slide', "currentSlide", "index","title","text", "texten"],
  methods: {
    drag2(event){
     event.preventDefault();
    },
  },
  data: () => ({
    slidesm1: [
     "/wp-content/uploads/2024/07/AROANIOS-PHOTO_19-scaled.jpg",
     "/wp-content/uploads/2024/07/AROANIOS-PHOTO_20-scaled.jpg",
    ],
  }),
}

</script>

<style>

.buttons-outline{
  display: flex;
}
.btn-outline {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
}

/* Green */
.color-outline {
  border-color: #04AA6D;
  color: green;
}

.color-outline:hover {
  background-color: #04AA6D;
  color: white;
}
.hero-header {
    box-shadow: -2px 2px 12px rgb(0 0 0 / 17%);
    backdrop-filter: blur(4px);
    border-radius: 20px;
    padding: 40px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
.carousel-item img{
  width: 100% !important;
}
</style>